module.exports = __webpack_public_path__ + "static/media/tour-1.0f8562a9.png";